import styled from 'styled-components';

export const StyledSkipToMainLink = styled.a`
  position: absolute;
  left: -9999px;
  z-index: 999;
  padding: 1em;
  background-color: black;
  color: white;
  opacity: 0;

  &:focus {
    transform: translateX(-50%);
    left: 50%;
    opacity: 1;
  }
`;
